/**
 * @ignore
 * Created by daletan on 8/28/16.
 */

'use strict';

const get = require('lodash.get');
const { formatPrice } = require('../../../components/Price/helpers.es');
const displayTransformations = require('./displayTransformations.json');

const getAmount = (amounts = [], currency) =>
    amounts.find(amount => amount && amount.currency === currency) || {};
const getFormattedPrice = (amounts = [], currency) => {
    const { amount } = getAmount(amounts, currency);
    return formatPrice({ price: amount, currency });
};

const createHandlingTimeCopy = ({
    is1stdibsWhiteGloveQuote,
    handlingType,
    handlingTimeDisplay,
    regionType,
}) => {
    let str = `${handlingType}: ${handlingTimeDisplay}`;
    if (is1stdibsWhiteGloveQuote && regionType !== 'LOCAL') {
        str = `1stdibs ${str}`;
    }
    return str;
};

const createOutputString = ({
    serviceMethod,
    buyerSubTotalAmount = {},
    currency,
    regionType,
    isLocalPrimary,
}) => {
    let region = get(serviceMethod, 'region.regionName');
    const amount = getAmount(get(buyerSubTotalAmount, 'convertedAmountList', []), currency);
    const { string, abbreviation } = formatPrice({ price: amount.amount, currency });
    let output = string;
    if (amount.amount === 0) {
        output = 'Complimentary';
    } else if (abbreviation) {
        output = `${output} ${abbreviation}`;
    }
    if (regionType === 'LOCAL' && !isLocalPrimary) {
        return `Local shipping starts at ${output}`;
    }
    if (region === 'Rest of the World') {
        region = 'anywhere in the world';
    }
    return `${output} shipping to ${region}`;
};

const getShippingQuote = ({ item = {}, currency, regionType, isLocalPrimary }) => {
    if (item.node) {
        const {
            serviceMethod,
            buyerSubTotalAmount,
            handlingTimeDisplay,
            is1stdibsWhiteGloveQuote,
        } = item.node;
        const key = item.node.__dataID__ || item.node.id;
        const handlingType =
            displayTransformations[serviceMethod.displayName] || serviceMethod.displayName || '';
        const handlingTimeCopy = createHandlingTimeCopy({
            is1stdibsWhiteGloveQuote,
            handlingType,
            handlingTimeDisplay,
            regionType,
        });
        const output = createOutputString({
            serviceMethod,
            buyerSubTotalAmount,
            currency,
            regionType,
            isLocalPrimary,
        });
        return {
            key,
            handlingTimeCopy,
            output,
        };
    }
    return {};
};

const filterQuote = ({ node }) =>
    node && get(node, 'serviceMethod.serviceMethodType') !== 'LOCAL_PICKUP';
const filterQuotes = (quotes = []) => quotes.filter(filterQuote);
const sortQuote = (prev, curr) => {
    const prevMinTime = get(prev, 'node.serviceMethod.windowMin.numberOfUnits') || 0;
    const currMinTime = get(curr, 'node.serviceMethod.windowMin.numberOfUnits') || 0;
    const prevHandlingTime = get(prev, 'node.handlingTime.numberOfUnits') || 0;
    const currHandlingTime = get(curr, 'node.handlingTime.numberOfUnits') || 0;
    return prevMinTime + prevHandlingTime - (currMinTime + currHandlingTime);
};

const getShipmentPrequotes = ({
    domesticDeliveryOptions = {},
    localDeliveryOptions = {},
    shipmentQuotes = {},
}) => {
    const domesticDeliveryQuotes = domesticDeliveryOptions.edges || [];
    const localDeliveryQuotes = localDeliveryOptions.edges || [];
    shipmentQuotes = shipmentQuotes.edges || [];

    return {
        domestic: filterQuotes(domesticDeliveryQuotes),
        local: filterQuotes(localDeliveryQuotes),
        shipmentQuotes: filterQuotes(shipmentQuotes),
    };
};

const helpers = {
    getValidQuote({ quotes, regionType, currency, isLocalPrimary = false }) {
        const filteredQuotes = filterQuotes(quotes);
        return getShippingQuote({ item: filteredQuotes[0], regionType, currency, isLocalPrimary });
    },
    getFormattedPrice,
    getShipmentPrequotes,
    filterQuotes,
    filterQuote,
    sortQuote,
};

module.exports = helpers;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Shipping/shippingHelpers.es.js